import {
  ALGOLIA_DEFAULT_PROPS,
  ALGOLIA_INDEX_NAME,
} from '@/lib/algolia/searchClient';
import { createInstantSearchRouterNext } from 'react-instantsearch-router-nextjs';
import singletonRouter from 'next/router';
import { parseURL } from '@/components/layout/Header/search/parseUrl';
import { Configure, InstantSearch } from 'react-instantsearch';
import ProductListHeaderInstantSearch from '@/components/layout/Header/search/ProductListHeaderSearch';
import { GetStaticProps } from 'next';
import { getNavigation } from '@/lib/sanity/queries';
import { createHeaderSearchUrl } from '@/components/layout/Header/search/createHeaderSearchUrl';
import { FakeSearchInput } from '@/components/layout/Header/search/FakeSearchInput';

const SearchPage = () => {
  return (
    <div className="w-full min-h-screen">
      <InstantSearch
        {...ALGOLIA_DEFAULT_PROPS}
        insights
        future={{
          preserveSharedStateOnUnmount: false,
        }}
        routing={{
          router: createInstantSearchRouterNext({
            singletonRouter,
            routerOptions: {
              cleanUrlOnDispose: false,
              createURL: createHeaderSearchUrl(ALGOLIA_INDEX_NAME),
              parseURL: parseURL(ALGOLIA_INDEX_NAME),
            },
          }),
        }}
      >
        <Configure hitsPerPage={24} page={0} clickAnalytics />
        <ProductListHeaderInstantSearch infiniteScroll />
        <FakeSearchInput />
      </InstantSearch>
    </div>
  );
};

export default SearchPage;

export const getStaticProps: GetStaticProps = async (context) => {
  const navigation = await getNavigation();

  return {
    props: { navigation },
    revalidate: 60 * 30,
  };
};
